import { Form, Input, Modal, DatePicker, Popover, Select } from 'antd';
import InputMask from 'react-input-mask';
import PropTypes from 'prop-types';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { regexDescription, regexInput } from 'utils/regex';
import { log } from 'utils';
import { CheckBullet, CopyOutlineIcon, PasteOutlineIcon, PlusIcon, TrashOutlineIcon } from '../../assets/icon/dynamic';
import './ModalScreenSchedulingForm.css';

const ModalScreenSchedulingForm = ({
  scheduling,
  setScheduling,
  visible,
  onCancel,
  onCreate,
  isEditing,
  siteId,
}) => {
  const [form] = Form.useForm();

  const { loading, screensList } = useSelector(
    (state) => ({
      loading: state.screenScheduling.loading,
      screensList: state.screens.list,
    }),
    shallowEqual
  );

  const [errors, setErrors] = useState({
    name: '',
    description: '',
  });
  const [allDay, setAllDay] = useState(true);
  const [days, setDays] = useState([
    {
      name: 'Sunday',
      alias: 'Sun',
      isActive: false,
      hours: [['00:00', '23:59']],
    },
    {
      name: 'Monday',
      alias: 'Mon',
      isActive: false,
      hours: [['00:00', '23:59']],
    },
    {
      name: 'Tuesday',
      alias: 'Tue',
      isActive: false,
      hours: [['00:00', '23:59']],
    },
    {
      name: 'Wednesday',
      alias: 'Wed',
      isActive: false,
      hours: [['00:00', '23:59']],
    },
    {
      name: 'Thursday',
      alias: 'Thu',
      isActive: false,
      hours: [['00:00', '23:59']],
    },
    {
      name: 'Friday',
      alias: 'Fri',
      isActive: false,
      hours: [['00:00', '23:59']],
    },
    {
      name: 'Saturday',
      alias: 'Sat',
      isActive: false,
      hours: [['00:00', '23:59']],
    },
  ]);

  const [isCopied, setIsCopied] = useState();
  const [copyTime, setCopyTime] = useState();
  const [activeConfigIndices, setActiveConfigIndices] = useState([0]);

  const dispatch = useDispatch();

  useEffect(() => {
    if (scheduling && isEditing) {
      setAllDay(!scheduling.days || scheduling.days.length === 0);
      if (scheduling.days && scheduling.days.length > 0) {
        const newDay = [...days];
        scheduling.days.forEach((day) => {
          const ind = newDay.findIndex((daynew) => daynew.name === day.day);
          if (ind !== -1) {
            newDay[ind].isActive = true;
            newDay[ind].hours = [];
            day.hours.forEach((hour) => newDay[ind].hours.push(hour.split('-')));
          }
        });
        setDays(newDay);
      }
      if (scheduling.activeConfigIndices) {
        setActiveConfigIndices(scheduling.activeConfigIndices);
      }
    }
  }, [scheduling]); //eslint-disable-line

  const handleChange = (name, value) => {
    setScheduling({
      ...scheduling,
      [name]: value,
    });
  };

  const onSave = (values) => {
    if (
      (!regexInput(values.name) && values.name) ||
      (!regexDescription(values.description) && values.description)
    ) {
      setErrors({
        ...errors,
        name:
          !regexInput(values.name) &&
          values.name &&
          'This field cannot contain any special characters',
        description:
          !regexDescription(values.description) &&
          values.description &&
          'This field cannot contain any special characters',
      });
    } else if (!scheduling.screenId) {
      setErrors({
        ...errors,
        name: 'Screen is required',
      });
    } else {
      setErrors({
        name: '',
        description: '',
      });
      const daysFilter = days
        .filter((x) => x.isActive)
        .map((x) => {
          return {
            day: x.name,
            hours: x.hours.map((hour) => {
              return hour && hour.join('-');
            }),
          };
        });
      onCreate({
        ...scheduling,
        id: scheduling._id,
        days: daysFilter,
        dates: [],
        activeConfigIndices,
      });
      form.resetFields();
    }
  };

  const handleChangeDate = (value) => {
    if (value) {
      setScheduling({
        ...scheduling,
        start: value[0].format(),
        end: value[1].format(),
      });
    } else {
      setScheduling({
        ...scheduling,
        start: null,
        end: null,
      });
    }
  };

  const handleChangeHour = (name, index, indexAgain, value) => {
    const data = [...days];
    if (name === 'from') {
      data[index].hours[indexAgain] = [value, data[index].hours[indexAgain][1]];
    } else if (name === 'to') {
      data[index].hours[indexAgain] = [data[index].hours[indexAgain][0], value];
    }
    if (
      data[index].hours[indexAgain][0].replace(/[^a-zA-Z0-9]/g, '').length ===
        4 &&
      data[index].hours[indexAgain][1].replace(/[^a-zA-Z0-9]/g, '').length === 4
    ) {
      if (data[index].hours[indexAgain][1] < data[index].hours[indexAgain][0]) {
        data[index].hours[indexAgain] = [
          data[index].hours[indexAgain][1],
          data[index].hours[indexAgain][0],
        ];
      }

      const before = data[index].hours[indexAgain][0];
      const after = data[index].hours[indexAgain][1];
      if (parseInt(before.substring(0, 2), 10) > 23) {
        data[index].hours[indexAgain][0] = data[index].hours[
          indexAgain
        ][0].replace(/^.{2}/g, '23');
      }
      if (parseInt(before.substring(3), 10) > 59) {
        data[index].hours[indexAgain][0] = data[index].hours[
          indexAgain
        ][0].replace(/.{0,2}$/, '59');
      }
      if (parseInt(after.substring(0, 2), 10) > 23) {
        data[index].hours[indexAgain][1] = data[index].hours[
          indexAgain
        ][1].replace(/^.{2}/g, '23');
      }
      if (parseInt(after.substring(3), 10) > 59) {
        data[index].hours[indexAgain][1] = data[index].hours[
          indexAgain
        ][1].replace(/.{0,2}$/, '59');
      }

      data[index].hours.sort((a, b) => {
        return (
          parseInt(a[0].replace(/[^a-zA-Z0-9]/g, ''), 10) -
          parseInt(b[0].replace(/[^a-zA-Z0-9]/g, ''), 10)
        );
      });
    }

    setDays([...data]);
  };

  const handleDeleteHourDay = (index, indexAgain) => {
    const newDay = [...days];
    if (newDay[index].hours.length > 1) {
      const filterHour = newDay[index].hours.filter(
        (_, ind) => ind !== indexAgain
      );

      newDay[index].hours = filterHour;
      setDays([...newDay]);
    } else {
      newDay[index].hours = [];
      setDays([...newDay]);
    }
  };

  const handleDeleteDay = (index) => {
    const newDay = [...days];
    newDay[index].hours = [];
    setDays(newDay);
  };

  const handleActiveDay = (index) => {
    const newDay = [...days];
    newDay[index].isActive = !newDay[index].isActive;
    setDays(newDay);
  };

  const handleAddHourDay = (index) => {
    const newDay = [...days];
    newDay[index].hours.push(['', '23.59']);
    setDays(newDay);
  };

  const handleCopyTime = (hours, index) => {
    setIsCopied(index);
    setCopyTime([...hours]);
    setTimeout(() => {
      setIsCopied();
    }, 1000);
  };

  const handlePasteTime = (index) => {
    if (copyTime) {
      const newDay = [...days];
      newDay[index].hours = copyTime;
      setCopyTime();
      setDays([...newDay]);
    }
  };

  const handleAddConfigIndex = () => {
    setActiveConfigIndices([...activeConfigIndices, activeConfigIndices.length]);
  };

  const handleRemoveConfigIndex = (index) => {
    const newIndices = activeConfigIndices.filter((_, i) => i !== index);
    setActiveConfigIndices(newIndices);
  };

  const handleChangeConfigIndex = (oldIndex, newValue) => {
    const newIndices = [...activeConfigIndices];
    newIndices[oldIndex] = parseInt(newValue, 10);
    setActiveConfigIndices(newIndices);
  };

  return (
    <Modal
      className="adsign-modal scheduling-form"
      open={visible}
      title={isEditing ? 'Edit Screen Scheduling' : 'Add New Screen Scheduling'}
      closeIcon={<i className="feather-x" />}
      okText="Submit"
      okButtonProps={{
        className: 'button-submit',
      }}
      cancelButtonProps={{
        className: 'button-cancel',
      }}
      confirmLoading={loading}
      onCancel={() => {
        onCancel();
        form.resetFields();
      }}
      onOk={() => {
        form
          .validateFields()
          .then((values) => {
            onSave(values);
          })
          .catch((info) => {
            log('Validate Failed:', info);
          });
      }}
    >
      <Form
        layout="vertical"
        form={form}
        initialValues={{
          name: scheduling.name,
          description: scheduling.description,
          screenId: scheduling.screenId,
        }}
      >
        <Form.Item
          label="Name"
          rules={[{ required: true, message: `'Name' is required` }]}
          validateStatus={errors.name ? 'error' : 'success'}
          help={errors.name ? errors.name : null}
        >
          <Input
            value={scheduling.name}
            placeholder="Enter scheduling's name"
            onChange={(e) => handleChange('name', e.target.value)}
          />
        </Form.Item>

        <Form.Item
          label="Screen"
          rules={[{ required: true, message: `'Screen' is required` }]}
        >
          <Select
            value={scheduling.screenId}
            placeholder="Select a screen"
            onChange={(value) => handleChange('screenId', value)}
          >
            {screensList.map((screen) => (
              <Select.Option key={screen._id} value={screen._id}>
                {screen.name}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item
          label="Description"
          validateStatus={errors.description ? 'error' : 'success'}
          help={errors.description ? errors.description : null}
        >
          <Input.TextArea
            rows={4}
            placeholder="Description"
            value={scheduling.description}
            onChange={(e) => handleChange('description', e.target.value)}
          />
        </Form.Item>

        <div className="form">
          <label className="form-label">
            Active Config Indices <span className="is-required">*</span>
          </label>
          <div className="config-indices-wrapper">
            {activeConfigIndices.map((configIndex, index) => (
              <div key={index} className="config-index-item">
                <Input
                  type="number"
                  min={0}
                  value={configIndex}
                  onChange={(e) => handleChangeConfigIndex(index, e.target.value)}
                  placeholder="Config index"
                />
                {activeConfigIndices.length > 1 && (
                  <button
                    className="button-link red-single"
                    type="button"
                    onClick={() => handleRemoveConfigIndex(index)}
                  >
                    <TrashOutlineIcon color="#CB3A31" size={20} />
                  </button>
                )}
              </div>
            ))}
            <button
              className="button-link primary"
              type="button"
              onClick={handleAddConfigIndex}
            >
              <PlusIcon color="#64D5D2" size={20} />
              Add Config Index
            </button>
          </div>
        </div>

        <div className="date-container">
          <div className="form">
            <label className="form-label">
              Start Date / End Date <span className="is-required">*</span>
            </label>
            <DatePicker.RangePicker
              style={{ width: '100%' }}
              className="datepicker-adsign"
              format="DD/MM/YYYY HH:mm"
              showTime
              onChange={handleChangeDate}
              value={
                scheduling.start && scheduling.end
                  ? [moment(scheduling.start), moment(scheduling.end)]
                  : undefined
              }
            />
            <div className="radio-container">
              <div
                className={`radio ${allDay ? 'active' : ''}`}
                onClick={() => setAllDay(true)}
              >
                {allDay && <CheckBullet color="#64D5D2" />}
              </div>
              <div className="radio-title">All Day - Time</div>
              <div
                className={`radio ${!allDay ? 'active' : ''}`}
                onClick={() => setAllDay(false)}
              >
                {!allDay && <CheckBullet color="#64D5D2" />}
              </div>
              <div className="radio-title">Custom Day - Time</div>
            </div>

            {!allDay &&
              days.map((day, index) => (
                <div className="daytime-wrapper" key={index}>
                  <div className="day-container">
                    <div
                      className={`radio ${day.isActive ? 'active' : ''}`}
                      onClick={() => {
                        handleActiveDay(index);
                      }}
                    >
                      {day.isActive && <CheckBullet color="#64D5D2" />}
                    </div>
                    <div className="radio-title">{day.name}</div>
                  </div>
                  {day.isActive &&
                    day.hours &&
                    day.hours.map((hour, indexHour) => {
                      const hourFrom = hour[0] ? hour[0] : '';
                      const hourTo = hour[1] ? hour[1] : '';
                      return (
                        <div
                          key={`${day + indexHour}`}
                          className="input-group space"
                        >
                          <InputMask
                            mask="99:99"
                            placeholder="00:00"
                            type="text"
                            value={hourFrom}
                            onChange={(e) =>
                              handleChangeHour(
                                'from',
                                index,
                                indexHour,
                                e.target.value
                              )
                            }
                          />
                          <span className="time-range">-</span>
                          <InputMask
                            mask="99:99"
                            placeholder="00:00"
                            type="text"
                            value={hourTo}
                            onChange={(e) => {
                              handleChangeHour(
                                'to',
                                index,
                                indexHour,
                                e.target.value
                              );
                            }}
                          />
                          <button
                            className="button-link red-single"
                            type="button"
                            onClick={() =>
                              handleDeleteHourDay(index, indexHour)
                            }
                          >
                            <TrashOutlineIcon color="#CB3A31" size={20} />
                          </button>
                        </div>
                      );
                    })}
                  {day.isActive && (
                    <div className="time-slot-menu">
                      <button
                        className="button-link primary"
                        type="button"
                        onClick={() => handleAddHourDay(index)}
                      >
                        <PlusIcon color="#64D5D2" size={20} />
                        Time Slot
                      </button>
                      <Popover
                        visible={isCopied === index}
                        content={
                          <p className="copied-popover">
                            <i className="feather-check" />
                            {day.hours.length}{' '}
                            {`Time Slot${
                              day.hours.length > 1 ? 's' : ''
                            } Copied!`}
                          </p>
                        }
                        trigger="click"
                      >
                        <button
                          className="button-link grey"
                          type="button"
                          onClick={() => handleCopyTime(day.hours, index)}
                        >
                          <CopyOutlineIcon size={18} color="#9E9E9E" />
                        </button>
                      </Popover>

                      <button
                        className="button-link grey"
                        type="button"
                        onClick={() => handlePasteTime(index)}
                      >
                        <PasteOutlineIcon size={18} color="#9E9E9E" />
                      </button>

                      <button
                        className="button-link red"
                        type="button"
                        onClick={() => handleDeleteDay(index)}
                      >
                        <TrashOutlineIcon color="#CB3A31" size={20} />
                        Delete All
                      </button>
                    </div>
                  )}
                </div>
              ))}
          </div>
        </div>
      </Form>
    </Modal>
  );
};

ModalScreenSchedulingForm.propTypes = {
  scheduling: PropTypes.shape({
    _id: PropTypes.string,
    name: PropTypes.string,
    description: PropTypes.string,
    screenId: PropTypes.string,
    activeConfigIndices: PropTypes.array,
  }),
  setScheduling: PropTypes.func.isRequired,
  visible: PropTypes.bool,
  onCancel: PropTypes.func,
  onCreate: PropTypes.func,
  isEditing: PropTypes.bool,
  siteId: PropTypes.string,
};

export default ModalScreenSchedulingForm;
